import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  action?: ReactNode
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 text-slate-400">
        {icon}
      </div>
      <h3 className="mb-1 text-base font-semibold text-slate-700">{title}</h3>
      <p className="mb-4 max-w-xs text-sm text-slate-500">{description}</p>
      {action && <div>{action}</div>}
    </div>
  )
}
